import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PAYMENT_INITIATION: PaymentMethod = {
    id: PAYMENT_METHOD_ID.PaymentInitiation,
    name: 'paymentinitiation'
};
